import { Environment } from '@freelancer/config';

export type ThemeSetting = 'light' | 'dark' | 'system';
export type Theme = 'light' | 'dark';

export const WHITELISTED_DARK_MODE_USERS = new Map<
  Environment,
  readonly number[]
>([
  [
    Environment.PROD,
    [
      // Staff
      1_082_831, // quartermaster
      7_829_672, // stefanocaioni
      30_609_349, // nebbsie

      // Freelancers/Clients
      589_141,
      1_194_363,
      1_248_998,
      1_377_069,
      1_536_056,
      2_139_103,
      2_164_709,
      3_269_485,
      3_582_030,
      4_394_264,
      6_835_533,
      7_121_917,
      8_052_315,
      8_956_708,
      9_770_132,
      10_408_748,
      10_502_959,
      10_888_845,
      10_936_703,
      11_093_067,
      11_116_137,
      11_870_648,
      11_884_164,
      13_142_893,
      13_574_926,
      13_767_632,
      14_001_274,
      14_424_419,
      14_590_314,
      14_798_398,
      15_018_773,
      15_429_953,
      15_596_126,
      15_702_752,
      15_798_863,
      16_302_881,
      16_608_227,
      17_711_176,
      17_883_400,
      18_054_316,
      18_089_442,
      18_351_477,
      19_830_318,
      20_249_593,
      20_491_926,
      20_585_553,
      20_859_428,
      23_264_268,
      23_477_389,
      23_543_725,
      23_624_897,
      23_755_092,
      23_791_599,
      25_059_547,
      25_326_023,
      25_501_440,
      25_667_551,
      25_962_765,
      26_340_018,
      27_634_591,
      28_777_871,
      29_582_895,
      30_861_004,
      31_279_980,
      33_237_683,
      33_838_180,
      34_205_968,
      38_041_668,
      38_347_416,
      39_031_507,
      40_108_108,
      42_123_020,
      42_783_825,
      43_742_410,
      44_703_394,
      45_019_609,
      45_512_387,
      48_783_928,
      48_896_657,
      50_370_266,
      50_708_897,
      50_800_336,
      51_306_258,
      53_603_886,
      55_236_279,
      55_239_943,
      55_387_253,
      56_529_999,
      56_802_577,
      57_032_741,
      59_651_839,
      60_499_855,
      61_083_719,
      61_479_855,
      62_940_264,
      64_643_109,
      66_593_396,
      66_632_545,
      68_658_952,
      70_295_256,
    ],
  ],
  [Environment.SANDBOX, []],
  [Environment.STG, []],
  [
    Environment.DEV,
    [
      30_766_758, // nebbsie
    ],
  ],
]);
